export const Footer = () => {


    return (
        <footer className="container min-vw-100 bg-dark d-flex justify-content-end">
            © Chris Schnell | All Rights Reserved
        </footer>
    );
}